import Keycloak from 'keycloak-js';
import { AuthConfig, AuthToken } from '../models';

let keycloak: Keycloak;

const createKeycloak = () => {
  keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM ?? '',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? '',
  });
};

export const initKeycloak = async (authConfig: AuthConfig) => {
  if (!keycloak) {
    createKeycloak();
  }

  return keycloak?.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    responseMode: 'query',
    redirectUri: authConfig.redirectUrl,
  });
};

const extractToken = () => ({
  jwt: keycloak.token ?? '',
  refreshJwt: keycloak.refreshToken ?? '',
});

export const getToken = async (authConfig: AuthConfig): Promise<AuthToken | undefined> => {
  if (!keycloak || keycloak?.loginRequired) {
    await initKeycloak(authConfig);
  }

  if (keycloak.authenticated) {
    return extractToken();
  }

  await keycloak.login();

  return undefined;
};

// Function to periodically check and renew the Keycloak token
export async function checkAndRenewToken() {
  try {
    await keycloak.updateToken(60);
    if (keycloak.authenticated) {
      return extractToken();
    }

    throw Error('[Auth] Problem relating to exchange token');
  } catch (error) {
    keycloak.clearToken();
    return undefined;
  }
}

export async function renewToken() {
  const token = await checkAndRenewToken();
  return token?.jwt;
}

export const logout = async (authConfig: AuthConfig) => {
  if (!keycloak) {
    await initKeycloak(authConfig);
  }

  await keycloak?.logout();
};
